import {fromJS, Map} from 'immutable';
import overviewActions from '../../actions/overview.actions';
import dieselReducer from 'epic-diesel-common/src/decorators/DieselReducer';
import {OverviewState} from './types';

const initialState: OverviewState = {
    backgroundImage: null,
    description: null,
    title: null,
    warningText: null,
    notEligibleMessage: null,
    faq: {
        title: null,
        faqItem: []
    },
    carousel: {
        type: null,
        title: null,
        items: []
    },
    benefitsSection: {
        title: null,
        benefits: []
    },
    imageArray: {
        type: null,
        title: null,
        items: []
    }
};

export const DEFAULT_STATE = fromJS(initialState);

export const overviewReducer = (state: Map<keyof OverviewState, any> = DEFAULT_STATE, action) => {
    let newState = state;
    switch (action.type) {
        case overviewActions.TYPES.GET_HOME_COMPLETE: {
            const {data} = action.payload.home;
            if (data) newState = fromJS(data);
            return newState;
        }
        default:
            return newState;
    }
};

export default dieselReducer('overview', overviewReducer);
